import * as contactApi from '../../api/contact'

// eslint-disable-next-line no-unused-vars
async function contact({ dispatch }, contactData) {
  await contactApi.contact(contactData)
  //dispatch('notify', { newNotification: { type: 'success', message: 'Kapcsolatfelvétel sikeres!' } })
}

const contactStore = {
  actions: {
    contact
  }
}

export default contactStore
